import {ComponentType} from 'react';
import HallwayMonitor from './HallwayMonitor';
import {withFeatureFlags} from 'src/hooks/useFeatureFlags';
import {connect} from 'react-redux';
import switchAccount from 'shared/actions/switch-account';
import {flashMessage} from 'shared/actions/notifications';
import {FeatureFlags} from 'src/services/FeatureFlagService';

export default connect(null, {flashMessage, switchAccount})(
  withFeatureFlags(HallwayMonitor as ComponentType<{featureFlags: FeatureFlags}>, ['user_deletion'])
);
